<header>

  <nav *ngIf="!isAuthenticated">
    <div class="container" style="background: rgb(0, 71, 0); min-height: 60px; box-shadow:0 0.25rem 0.25rem rgb(0 0 0 / 25%);"
      class="navbar-light  border-bottom mb-3">
    </div>
  </nav>


  <nav *ngIf="isAuthenticated">
    <div class="container" style="text-align: center; min-height: 60px; margin: 10px 0;" class="navbar-light  border-bottom box-shadow mb-3">
      <img src="/images/t2.png" height="40" />
      &nbsp;&nbsp;&nbsp;
      <a class="navbar-brand" [routerLink]="['/home']">Tennis Ladder</a>
      <!-- get ladder name from users's profile.... through DB key -->
    </div>
  </nav>
</header>
<div *ngIf="isAuthenticated" id="nav-menu" style="margin-bottom: 20px; align-items: center; text-align: center;">

  <table>
    <tr>
      <td><a id="myrecord" class="" [routerLink]="['/home']">My Record</a></td>
      <!-- <td><a class="" [routerLink]="['/rounds']">Rounds</a></td> -->
      <td><a id="players" class="" [routerLink]="['/players']">Players</a></td>
      <td><a id="standings" *ngIf="!isTiebreakTourney" class="" [routerLink]="['/scores']">Standings</a></td>
      <td><a id="standigns2" *ngIf="isTiebreakTourney" class="" [routerLink]="['/tiebreakgrid']">Standings</a></td>
      <td><a id="mylevels" class="" [routerLink]="['/ladderlevel']">My Ladders/Levels</a></td>
    </tr>
  </table>

</div>

<!-- 
<header>
  <nav class=" navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
    <div class="container">
      <a class="navbar-brand" [routerLink]="['/']">Tennis Ladder - </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation"
        [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse" [ngClass]="{ show: isExpanded }">
        <app-login-menu></app-login-menu>
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link text-dark" [routerLink]="['/']">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link text-dark" [routerLink]="['/record']">Record</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link text-dark" [routerLink]="['/players']">Players</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link text-dark" [routerLink]="['/scores']">Scores</a>
          </li>
        </ul>
      </div>
    </div>
    </nav>
    </header> -->